import { Routes } from '@angular/router';
import { ProgramViewComponent } from './program-view/program-view.component';
import { ProgramDashboardComponent } from './program-dashboard/program-dashboard.component';
import { ProgramContractsComponent } from './program-contracts/program-contracts.component';

export const ProgramRoutes: Routes = [
  {
    path: 'program/:programId',
    component: ProgramViewComponent,
    children: [
      {
        path: 'dashboard',
        component: ProgramDashboardComponent
      },
      {
        path: 'contract',
        component: ProgramContractsComponent
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'prefix'
      }
    ]
  }
];
